import React, { useState, useEffect, Suspense } from 'react';
import Loader from '../components/loader';

export function asyncWrapper (Component, keyCalculator, fallback = <Loader />) {
    const suspendedContent = ({ ...props }) => {
        if (!props.key && keyCalculator) props.key = keyCalculator(props);

        // Will be fixed, used for event loop synchronization (but bad practice)
        const [locked, setLocked] = useState(true);
        useEffect(() => { setLocked(false); }, []);

        return <Suspense fallback={fallback}>
            {!locked && <Component {...props} />}
        </Suspense>
    };

    return suspendedContent;
}